/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "FWi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style.css
var style = __webpack_require__("FWi5");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/Hero.js


var Hero__ref = Object(preact_min["h"])(
  "div",
  { "class": "hero-head" },
  Object(preact_min["h"])(
    "nav",
    { "class": "navbar" },
    Object(preact_min["h"])(
      "div",
      { "class": "container" },
      Object(preact_min["h"])(
        "div",
        { "class": "navbar-brand" },
        Object(preact_min["h"])(
          "a",
          { "class": "navbar-item" },
          Object(preact_min["h"])(
            "h1",
            { "class": "title is-size-2" },
            "CONGREX"
          )
        ),
        Object(preact_min["h"])(
          "span",
          { "class": "navbar-burger burger", "data-target": "navbarMenuHeroA" },
          Object(preact_min["h"])("span", null),
          Object(preact_min["h"])("span", null),
          Object(preact_min["h"])("span", null)
        )
      ),
      Object(preact_min["h"])(
        "div",
        { id: "navbarMenuHeroA", "class": "navbar-menu" },
        Object(preact_min["h"])(
          "div",
          { "class": "navbar-end" },
          Object(preact_min["h"])(
            "a",
            { href: "#about", "class": "navbar-item" },
            "About"
          ),
          Object(preact_min["h"])(
            "a",
            { href: "#representative-grid", "class": "navbar-item" },
            "Explore"
          ),
          Object(preact_min["h"])(
            "a",
            { href: "#faq", "class": "navbar-item" },
            "F.A.Q"
          ),
          Object(preact_min["h"])(
            "a",
            {
              href: "https://rinkeby.opensea.io/accounts/0xd749adf80793616663993144a9ed3c11bcd186fa",
              "class": "navbar-item",
              target: "_blank",
              rel: "nofollow noreferrer"
            },
            "Trade"
          )
        )
      )
    )
  )
);

// TODO: handle mobile hero nav onClick
var Head = function Head() {
  return Hero__ref;
};

var _ref2 = Object(preact_min["h"])("img", { "class": "image is-logo is-square", src: "../assets/images/logo.png" });

var _ref3 = Object(preact_min["h"])(
  "h2",
  { "class": "shimmer subtitle is-size-2 is-hidden-mobile" },
  "Limited Edition Collectibles of United States Congress Members on the Ethereum Blockchain"
);

var _ref4 = Object(preact_min["h"])(
  "h2",
  { "class": "shimmer subtitle is-size-4 is-hidden-tablet" },
  "Limited Edition Collectibles of United States Congress Members on the Ethereum Blockchain"
);

var Hero_Body = function Body() {
  return Object(preact_min["h"])(
    "div",
    { "class": "hero-body" },
    Object(preact_min["h"])(
      "div",
      { "class": "container has-text-centered" },
      _ref2,
      _ref3,
      _ref4
    )
  );
};

var _ref5 = Object(preact_min["h"])(
  "div",
  { "class": "hero-footer" },
  Object(preact_min["h"])(
    "nav",
    { "class": "level is-mobile" },
    Object(preact_min["h"])(
      "div",
      { "class": "level-item has-text-centered" },
      Object(preact_min["h"])(
        "div",
        null,
        Object(preact_min["h"])(
          "p",
          { "class": "title" },
          "553 tokens"
        ),
        Object(preact_min["h"])(
          "p",
          { "class": "heading is-size-7" },
          "from the"
        ),
        Object(preact_min["h"])(
          "p",
          { "class": "title" },
          "115th Congress"
        )
      )
    )
  )
);

var Footer = function Footer() {
  return _ref5;
};

var _ref6 = Object(preact_min["h"])(
  "section",
  { "class": "hero is-link is-fullheight" },
  Object(preact_min["h"])(Head, null),
  Object(preact_min["h"])(Hero_Body, null),
  Object(preact_min["h"])(Footer, null)
);

/* harmony default export */ var Hero = (function () {
  return _ref6;
});
// CONCATENATED MODULE: ./components/About.js


var About__ref = Object(preact_min["h"])(
    "div",
    { "class": "columns features" },
    Object(preact_min["h"])(
        "div",
        { "class": "column is-4" },
        Object(preact_min["h"])(
            "div",
            { "class": "card is-shady" },
            Object(preact_min["h"])(
                "div",
                { "class": "card-image has-text-centered" },
                Object(preact_min["h"])("i", { "class": "fa fa-dove fa-5x" })
            ),
            Object(preact_min["h"])(
                "div",
                { "class": "card-content" },
                Object(preact_min["h"])(
                    "div",
                    { "class": "content has-text-centered" },
                    Object(preact_min["h"])(
                        "h4",
                        null,
                        "Tristique senectus et netus et. "
                    ),
                    Object(preact_min["h"])(
                        "p",
                        null,
                        "Purus semper eget duis at tellus at urna condimentum mattis. Non blandit massa enim nec. Integer enim neque volutpat ac tincidunt vitae semper quis."
                    )
                )
            )
        )
    ),
    Object(preact_min["h"])(
        "div",
        { "class": "column is-4" },
        Object(preact_min["h"])(
            "div",
            { "class": "card is-shady" },
            Object(preact_min["h"])(
                "div",
                { "class": "card-image has-text-centered" },
                Object(preact_min["h"])("i", { "class": "fab fa-ethereum fa-5x" })
            ),
            Object(preact_min["h"])(
                "div",
                { "class": "card-content" },
                Object(preact_min["h"])(
                    "div",
                    { "class": "content has-text-centered" },
                    Object(preact_min["h"])(
                        "h4",
                        null,
                        "Tempor orci dapibus ultrices in."
                    ),
                    Object(preact_min["h"])(
                        "p",
                        null,
                        "Ut venenatis tellus in metus vulputate. Amet consectetur adipiscing elit pellentesque. Sed arcu non odio euismod lacinia at quis risus."
                    )
                )
            )
        )
    ),
    Object(preact_min["h"])(
        "div",
        { "class": "column is-4" },
        Object(preact_min["h"])(
            "div",
            { "class": "card is-shady" },
            Object(preact_min["h"])(
                "div",
                { "class": "card-image has-text-centered" },
                Object(preact_min["h"])("i", { "class": "fa fa-address-card fa-5x" })
            ),
            Object(preact_min["h"])(
                "div",
                { "class": "card-content" },
                Object(preact_min["h"])(
                    "div",
                    { "class": "content has-text-centered" },
                    Object(preact_min["h"])(
                        "h4",
                        null,
                        " Leo integer malesuada nunc vel risus. "
                    ),
                    Object(preact_min["h"])(
                        "p",
                        null,
                        "Imperdiet dui accumsan sit amet nulla facilisi morbi. Fusce ut placerat orci nulla pellentesque dignissim enim. Libero id faucibus nisl tincidunt eget nullam."
                    )
                )
            )
        )
    )
);

var Cards = function Cards() {
    return About__ref;
};

var About__ref2 = Object(preact_min["h"])(
    "section",
    { id: "about", "class": "section is-donations is-small is" },
    Object(preact_min["h"])(
        "h2",
        { "class": "title has-text-centered" },
        "About"
    ),
    Object(preact_min["h"])(
        "p",
        { "class": "has-text-centered" },
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec nec justo ut elit tristique bibendum. Pellentesque est diam, posuere ac orci a, molestie ornare libero. Aliquam ut vulputate libero. Nullam id augue quis elit fringilla tincidunt. Suspendisse sed elit varius, viverra augue non, ultrices erat."
    ),
    Object(preact_min["h"])(Cards, null)
);

/* harmony default export */ var About = (function () {
    return About__ref2;
});
// CONCATENATED MODULE: ./components/RepCard.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var RepCard__ref = Object(preact_min["h"])(
  'figure',
  { 'class': 'opensea image is-24x24' },
  Object(preact_min["h"])('img', { src: '../assets/images/opensea-icon.png' })
);

var RepCard__ref2 = Object(preact_min["h"])(
  'p',
  { 'class': 'card-footer-item' },
  Object(preact_min["h"])(
    'span',
    null,
    Object(preact_min["h"])(
      'span',
      { 'class': 'icon is-medium' },
      Object(preact_min["h"])('i', { 'class': 'fas fa-university' })
    ),
    Object(preact_min["h"])(
      'span',
      { 'class': 'icon is-medium' },
      Object(preact_min["h"])('i', { 'class': 'fab fa-facebook' })
    ),
    Object(preact_min["h"])(
      'span',
      { 'class': 'icon is-medium' },
      Object(preact_min["h"])('i', { 'class': 'fab fa-twitter' })
    )
  )
);

var RepCard_RepCard = function (_Component) {
  _inherits(RepCard, _Component);

  function RepCard() {
    var _temp, _this, _ret;

    _classCallCheck(this, RepCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onImgError = function (e) {
      console.log('Congress Token Card onImgError: ' + e);
      e.target.src = 'assets/images/placeholder.png';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  RepCard.prototype.componentWillMount = function componentWillMount() {};

  RepCard.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        attributes = _props.attributes,
        background_color = _props.background_color,
        description = _props.description,
        image = _props.image,
        name = _props.name,
        tokenId = _props.tokenId,
        id = _props.id,
        title = _props.title,
        date_of_birth = _props.date_of_birth,
        gender = _props.gender,
        party = _props.party,
        chamber = _props.chamber,
        state = _props.state,
        current_meeting = _props.current_meeting,
        next_election = _props.next_election;


    return Object(preact_min["h"])(
      'div',
      { 'class': 'column is-full-mobile is-half-tablet is-one-third-desktop is-one-third-widescreen is-one-quarter-fullhd' },
      Object(preact_min["h"])(
        'div',
        { 'class': 'card', style: 'border: 3px solid #' + background_color },
        Object(preact_min["h"])(
          'div',
          { 'class': 'card-content' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'media' },
            Object(preact_min["h"])(
              'div',
              { 'class': 'media-left' },
              Object(preact_min["h"])(
                'figure',
                { 'class': 'image is-64x64' },
                Object(preact_min["h"])('img', { src: 'assets/images/congress/100x100/' + id + '.jpg', alt: 'photo of CONGRESS token #' + tokenId + ', ' + title + ' ' + name, onError: function onError(e) {
                    return _this2.onImgError(e);
                  } })
              )
            ),
            Object(preact_min["h"])(
              'div',
              { 'class': 'media-content' },
              Object(preact_min["h"])(
                'p',
                { 'class': 'title is-5' },
                '#',
                tokenId,
                ' ',
                name
              ),
              Object(preact_min["h"])(
                'p',
                { 'class': 'subtitle is-6' },
                description
              )
            )
          )
        ),
        Object(preact_min["h"])(
          'footer',
          { 'class': 'card-footer' },
          Object(preact_min["h"])(
            'p',
            { 'class': 'card-footer-item' },
            Object(preact_min["h"])(
              'span',
              { 'class': 'has-text-centered' },
              RepCard__ref,
              Object(preact_min["h"])(
                'a',
                {
                  'class': 'title is-size-5',
                  target: '_blank',
                  rel: 'nofollow noreferrer',
                  href: 'https://rinkeby.opensea.io/assets/0x71a7bc84135e32de9fff35e91d7b5e7b5b4b80e4/' + tokenId
                },
                'Trade'
              )
            )
          ),
          RepCard__ref2
        )
      )
    );
  };

  return RepCard;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/RepGrid.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function RepGrid__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RepGrid__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function RepGrid__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var RepGrid__ref = Object(preact_min["h"])(
  'div',
  { id: 'representative-grid', 'class': 'section is-medium has-background-info has-text-centered' },
  Object(preact_min["h"])(
    'span',
    { 'class': 'icon is-large', style: 'padding: 10vh 0; color: white;' },
    Object(preact_min["h"])('i', { 'class': 'fas fa-spinner fa-3x fa-pulse' })
  )
);

var RepGrid__ref2 = Object(preact_min["h"])(
  'h3',
  { 'class': 'title has-text-centered has-text-white is-size-1' },
  'Explore'
);

var RepGrid__ref3 = Object(preact_min["h"])(
  'span',
  { 'class': 'icon is-small is-left' },
  Object(preact_min["h"])('i', { 'class': 'fas fa-search' })
);

var RepGrid_RepGrid = function (_Component) {
  RepGrid__inherits(RepGrid, _Component);

  function RepGrid() {
    var _temp, _this, _ret;

    RepGrid__classCallCheck(this, RepGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = RepGrid__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      filter: '',
      CongressMetaData: null
    }, _this.handleInput = function () {
      var _document$getElementB = document.getElementById('repSearch'),
          value = _document$getElementB.value;

      _this.setState({ filter: value });
    }, _this.filter = function (el, i, all) {
      var filter = _this.state.filter;
      var name = el.name,
          attributes = el.attributes;
      var state = attributes.state;


      if (filter == '' && i > 5) {
        return false;
      }

      if ((name + ' ' + state).toLowerCase().indexOf(filter.toLowerCase()) !== -1) {
        return true;
      } else {
        return false;
      }
    }, _temp), RepGrid__possibleConstructorReturn(_this, _ret);
  }

  RepGrid.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    fetch('/assets/metadata/tokens.json').then(function (d) {
      return d.json();
    }).then(function (CongressMetaData) {
      CongressMetaData = CongressMetaData.map(function (tkn) {
        tkn.attributes.forEach(function (attr) {
          tkn[attr.trait_type] = attr.value;
        });
        return tkn;
      });
      setTimeout(function () {
        _this2.setState({ CongressMetaData: CongressMetaData });
      }, 1000);
    });
  };

  RepGrid.prototype.render = function render() {
    var _this3 = this;

    var _state = this.state,
        CongressMetaData = _state.CongressMetaData,
        filter = _state.filter;

    if (!CongressMetaData) {
      return RepGrid__ref;
    }

    return Object(preact_min["h"])(
      'div',
      { id: 'representative-grid', 'class': 'section repGrid is-medium' },
      RepGrid__ref2,
      Object(preact_min["h"])(
        'div',
        { 'class': 'search box' },
        Object(preact_min["h"])(
          'div',
          { 'class': 'field' },
          Object(preact_min["h"])(
            'div',
            { 'class': 'control is-expanded has-icons-left' },
            Object(preact_min["h"])('input', { id: 'repSearch', onInput: function onInput(e) {
                return _this3.handleInput(e);
              }, 'class': 'input has-text-centered is-large is-rounded', type: 'search', placeholder: 'Find A Representative' }),
            RepGrid__ref3
          )
        )
      ),
      Object(preact_min["h"])(
        'div',
        { 'class': 'columns is-multiline' },
        CongressMetaData.filter(this.filter).map(function (md, i) {
          return Object(preact_min["h"])(RepCard_RepCard, _extends({}, md, { key: i }));
        })
      )
    );
  };

  return RepGrid;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/Faq.js


function Faq__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Faq__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Faq__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var LoremIpsum = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque risus mi, tempus quis placerat ut, porta nec nulla. Vestibulum rhoncus ac ex sit amet fringilla. Nullam gravida purus diam, et dictum felis venenatis efficitur. Aenean ac eleifend lacus, in mollis lectus. Donec sodales, arcu et sollicitudin porttitor, tortor urna tempor ligula, id porttitor mi magna a neque. Donec dui urna, vehicula et sem eget, facilisis sodales sem.";

var Faq__ref2 = Object(preact_min["h"])(
  "div",
  { "class": "message-body" },
  LoremIpsum
);

var Faq_Msg = function Msg(_ref) {
  var q = _ref.q,
      m = _ref.m,
      showIndex = _ref.showIndex,
      i = _ref.i,
      setShown = _ref.setShown;
  return Object(preact_min["h"])(
    "article",
    { "class": "message is-marginless" },
    Object(preact_min["h"])(
      "div",
      { "class": "message-header", onClick: function onClick(e) {
          return showIndex === i ? setShown(-1) : setShown(i);
        } },
      Object(preact_min["h"])(
        "p",
        null,
        q
      ),
      Object(preact_min["h"])(
        "a",
        { "class": "button is-small is-outlined" },
        Object(preact_min["h"])(
          "span",
          { "class": "icon is-small" },
          Object(preact_min["h"])("i", { "class": "fa " + (showIndex === i ? 'fa-minus' : 'fa-expand-arrows-alt') })
        )
      )
    ),
    showIndex === i && Faq__ref2
  );
};

var Faq__ref3 = Object(preact_min["h"])(
  "h2",
  { "class": "title is-size-1 has-text-white has-text-centered" },
  "F.A.Q"
);

var Faq_FAQ = function (_Component) {
  Faq__inherits(FAQ, _Component);

  function FAQ() {
    var _temp, _this, _ret;

    Faq__classCallCheck(this, FAQ);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Faq__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      faqList: [{ q: 'What are Congress Tokens?', m: LoremIpsum }, { q: 'What do I need to buy & sell Congress Tokens?', m: LoremIpsum }, { q: 'How much do Congress Tokens cost?', m: LoremIpsum }, { q: 'Is this legal?', m: LoremIpsum }],
      showIndex: -1
    }, _this.setShown = function (i) {
      _this.setState({ showIndex: i });
    }, _temp), Faq__possibleConstructorReturn(_this, _ret);
  }

  FAQ.prototype.render = function render() {
    var _this2 = this;

    var _state = this.state,
        faqList = _state.faqList,
        showIndex = _state.showIndex;


    return Object(preact_min["h"])(
      "section",
      { id: "faq", "class": "section is-faq is-small" },
      Object(preact_min["h"])(
        "div",
        { "class": "container" },
        Faq__ref3,
        faqList.map(function (faq, i) {
          return Object(preact_min["h"])(Faq_Msg, { q: faq.q, m: faq.m, i: i, showIndex: showIndex, setShown: _this2.setShown });
        })
      )
    );
  };

  return FAQ;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/NonProfits.js

var imgStyle = {
  width: 200
};

var NonProfits__ref = Object(preact_min["h"])(
  "section",
  { id: "nonprofits", "class": "section is-donations is-small is" },
  Object(preact_min["h"])(
    "h2",
    { "class": "title has-text-centered" },
    "Supporting Political Oversight",
    Object(preact_min["h"])("br", null),
    "with Blockchain"
  ),
  Object(preact_min["h"])(
    "nav",
    { "class": "level is-paddingless\t" },
    Object(preact_min["h"])(
      "p",
      { "class": "level-item has-text-centered" },
      Object(preact_min["h"])(
        "a",
        { href: "https://sunlightfoundation.com/about/", target: "_blank", rel: "nofollow noreferrer" },
        Object(preact_min["h"])("img", { src: "../assets/images/nonprofits/SunlightFoundation.gif", alt: "", style: imgStyle })
      )
    ),
    Object(preact_min["h"])(
      "p",
      { "class": "level-item has-text-centered" },
      Object(preact_min["h"])(
        "a",
        { href: "https://coincenter.org/about", target: "_blank", rel: "nofollow noreferrer" },
        Object(preact_min["h"])("img", { src: "./assets/images/nonprofits/CoinCenter.png", alt: "", style: imgStyle })
      )
    ),
    Object(preact_min["h"])(
      "p",
      { "class": "level-item has-text-centered" },
      Object(preact_min["h"])(
        "a",
        { href: "https://www.propublica.org/about", target: "_blank", rel: "nofollow noreferrer" },
        Object(preact_min["h"])("img", { src: "../assets/images/nonprofits/ProPublica.png", alt: "", style: imgStyle })
      )
    )
  ),
  Object(preact_min["h"])(
    "h4",
    { "class": "subtitle has-text-centered" },
    "100% of proceeds donated"
  )
);

/* harmony default export */ var NonProfits = (function () {
  return NonProfits__ref;
});
// CONCATENATED MODULE: ./components/Footer.js

var Footer_Anchor = function Anchor(_ref) {
  var _link = _ref._link,
      _icon = _ref._icon;
  return Object(preact_min["h"])(
    "a",
    { href: _link /*target="_blank" rel="noreferrer nofollow"*/ },
    Object(preact_min["h"])("i", { "class": "fab fa-fw fa-lg " + _icon })
  );
};

var Footer__ref2 = Object(preact_min["h"])(
  "footer",
  { "class": "footer" },
  Object(preact_min["h"])(
    "div",
    { "class": "container" },
    Object(preact_min["h"])(
      "div",
      { "class": "content has-text-centered" },
      Object(preact_min["h"])(
        "p",
        null,
        Object(preact_min["h"])(
          "span",
          { "class": "icons" },
          Object(preact_min["h"])(Footer_Anchor, {
            _link: "#",
            _icon: "fa-github"
          }),
          Object(preact_min["h"])(Footer_Anchor, {
            _link: "https://rinkeby.etherscan.io/address/0x547AE95FDFf94C59191549aE3f0005e4D4e03Df8",
            _icon: "fa-ethereum"
          }),
          Object(preact_min["h"])(Footer_Anchor, {
            _link: "#",
            _icon: "fa-twitter"
          })
        )
      ),
      Object(preact_min["h"])(
        "p",
        { "class": "is-size-4" },
        Object(preact_min["h"])(
          "strong",
          null,
          "\xA9 2018 CONGREX"
        )
      )
    )
  )
);

/* harmony default export */ var components_Footer = (function () {
  return Footer__ref2;
});

// TODO: modal informing user about peepeth.com
// const twitterModal = () => (
//   <div class="modal">
//     <div class="modal-background"></div>
//     <div class="modal-card">
//       <header class="modal-card-head">
//         <p class="modal-card-title">Modal title</p>
//         <button class="delete" aria-label="close"></button>
//       </header>
//       <section class="modal-card-body">
//         <!-- Content ... -->
//       </section>
//       <footer class="modal-card-foot">
//         <button class="button is-success">Save changes</button>
//         <button class="button">Cancel</button>
//       </footer>
//     </div>
//   </div>
// )
// CONCATENATED MODULE: ./index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return App; });


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var index__ref = Object(preact_min["h"])(
  'div',
  { 'class': 'box has-background-link cta' },
  Object(preact_min["h"])(
    'p',
    { 'class': 'has-text-centered has-text-white is-size-6' },
    'Website Under ',
    Object(preact_min["h"])(
      'span',
      { 'class': 'tag is-warning is-size-6' },
      'Construction'
    )
  )
);

var Cta = function Cta() {
  return index__ref;
};

var index__ref2 = Object(preact_min["h"])(
  'div',
  null,
  Object(preact_min["h"])(Cta, null),
  Object(preact_min["h"])(Hero, null),
  Object(preact_min["h"])(About, null),
  Object(preact_min["h"])(RepGrid_RepGrid, null),
  Object(preact_min["h"])(NonProfits, null),
  Object(preact_min["h"])(Faq_FAQ, null),
  Object(preact_min["h"])(components_Footer, null)
);

var App = function (_Component) {
  index__inherits(App, _Component);

  function App() {
    index__classCallCheck(this, App);

    return index__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  App.prototype.render = function render() {
    return index__ref2;
  };

  return App;
}(preact_min["Component"]);



/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.c542e.js